<template>
  <div class="card assignment-card h-100 col-12">
    <div class="card-body">
      <div class="d-flex align-items-start">
        <div class="avatar-container">
          <img
            :src="assignment.teacher?.image_url || defaultAvatar"
            class="avatar rounded-circle"
            :alt="$t('assignments.teacherImageAlt')"
            @error="handleImageError"
          />
        </div>
        <div class="flex-grow-1">
          <div class="d-flex justify-content-between align-items-start">
            <div>
              <h5 class="mb-1">{{ assignment.teacher?.name || '—' }}</h5>
              <p class="text-muted mb-1">
                <i class="fas fa-envelope me-2"></i>{{ assignment.teacher?.email || '—' }}
              </p>
            </div>
            <button 
              @click.stop="$emit('delete', assignment)"
              class="btn btn-link text-danger p-0"
              :title="$t('assignments.cancelAssignment')"
              v-can="'class_group_teachers.delete'"
            >
              <i class="fas fa-trash"></i>
            </button>
          </div>
          
          <div class="d-flex gap-2 mb-2">
            <span class="badge bg-secondary">
              {{ assignment.subject?.name || '—' }}
              <span v-if="assignment.subject?.code">({{ assignment.subject.code }})</span>
            </span>
            <span class="badge bg-info">
              {{ assignment.group?.name || '—' }}
            </span>
          </div>
          
          <div class="assignment-details mt-2">
            <p class="mb-1">
              <i class="fas fa-school me-2"></i>
              <span class="fw-medium">{{ $t('assignments.class') }}:</span>
              {{ assignment.class?.name || '—' }}
            </p>
            <p class="mb-0">
              <i class="fas fa-calendar me-2"></i>
              <span class="fw-medium">{{ $t('assignments.assignedDate') }}:</span>
              {{ formatDate(assignment?.created_at) }}
            </p>
            <p v-if="assignment?.teacher?.salary_type !== 'fixed'" class="mb-0 mt-1">
              <i class="fas fa-coins me-2"></i>
              <span class="fw-medium">{{ $t('assignments.lessonPrice') }}:</span>
              {{ Number(assignment?.lesson_price || 0) }} {{ $t('common.currency') }}
            </p>
            <p
              v-if="assignment?.teacher?.salary_type === 'fixed' || assignment?.teacher?.salary_type === 'fixed_plus_lessons'"
              class="mb-0 mt-1"
            >
              <i class="fas fa-money-bill-wave me-2"></i>
              <span class="fw-medium">{{ $t('assignments.paidByFixedSalary') }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';

defineProps({
  assignment: {
    type: Object,
    required: true
  }
});

defineEmits(['delete']);

const defaultAvatar = '/images/default-avatar.png';

const formatDate = (dateString) => {
  if (!dateString) return "—";
  const d = new Date(dateString);
  if (Number.isNaN(d.getTime())) return "—";

  return d.toLocaleDateString("ar", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};


const handleImageError = (event) => {
  event.target.src = defaultAvatar;
};
</script>

<style scoped>
.assignment-card {
  transition: transform 0.2s;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.assignment-card:hover {
  transform: translateY(-5px);
}

.avatar-container {
  width: 80px;
  height: 80px;
}

.avatar {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.assignment-details {
  background-color: #f8f9fa;
  padding: 0.75rem;
  border-radius: 0.5rem;
  margin-top: 1rem;
}

.btn-link.text-danger {
  color: #dc3545;
}

.btn-link.text-danger:hover {
  color: #bb2d3b !important;
}
</style>
